import i18n from './../lang/i18n';
const useLang = () => {
    return i18n.language;
}
export default useLang;